import { NgModule } from '@angular/core';

/**
 * Common Modules
 */
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/**
 * Kendo UI Modules
 */
import { DialogModule } from '@progress/kendo-angular-dialog';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { TabStripModule, LayoutModule } from '@progress/kendo-angular-layout';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule, } from '@progress/kendo-angular-dropdowns';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';


/**
 * CGP Modules
 */
import { CgpUserProfileDialogModule } from './cgp-user-profile-dialog/cgp-user-profile-dialog.module';
import { CgpAppBarModule } from './cgp-app-bar/cgp-app-bar.module';
import { CgpSidenavComponent } from './cgp-sidenav/cgp-sidenav.component';
import { CgpAlertDialogModule } from './cgp-alert-dialog/cgp-alert-dialog.module';
import { CgpConfirmationDialogModule } from './cgp-confirmation-dialog/cgp-confirmation-dialog.module';
import { CgpBreadcrumbsModule } from './cgp-breadcrumbs/cgp-breadcrumbs.module';
import { CgpSnackbarModule } from './cgp-snackbar/cgp-snackbar.module';
import { CgpIdleModule } from './cgp-idle/cgp-idle.module';
import { CgpSidenavService } from './cgp-sidenav/cgp-sidenav.service';
import { CgpApiService } from '../../modules/cgp-api';
import { CgpIdleService } from './cgp-idle/cgp-idle.service';
import { CgpPanelModule } from './cgp-panel/cgp-panel.module';
import { CgpFooterComponent } from './cgp-footer/cgp-footer.component';

/**
 * Common Pipes
 */

import { PipesModule } from './pipes/pipes.module';

/**
 * Services
 */
import { RouteValidationService } from "./route-validation.service";
import { AuthGuard } from '../auth.guard';
import { DataGridComponent } from './data-grid/data-grid.component';
import { FormDialogComponent } from './form-dialog/form-dialog.component';
import { DataGridModule } from './data-grid/data-grid.module';
import { FormDialogModule } from './form-dialog/form-dialog.module';
import { NavToolbarModule } from './nav-toolbar/nav-toolbar.module';
import { StepperModule } from './stepper/stepper.module';
import { StepperComponent } from './stepper/stepper.component'
import { UploadModule } from '@progress/kendo-angular-upload';
import { ExpandablePanelbarModule } from './expandable-panelbar/expandable-panelbar.module';
import { ExpandablePanelbarComponent } from './expandable-panelbar/expandable-panelbar.component';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { SortableModule } from '@progress/kendo-angular-sortable';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LayoutModule,
    SortableModule,
    CgpAlertDialogModule,
    CgpConfirmationDialogModule,
    CgpBreadcrumbsModule,
    CgpSnackbarModule,
    CgpAppBarModule,
    CgpIdleModule,
    PipesModule,
    UploadModule,
    DataGridModule,
    FormDialogModule,
    NavToolbarModule,
    StepperModule,
    MatTooltipModule,
    ExpandablePanelbarModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
  ],
  declarations: [
    CgpSidenavComponent,
    CgpFooterComponent,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SwitchModule,
    NumericTextBoxModule,
    AutoCompleteModule,
    MultiSelectModule,
    ComboBoxModule,
    DropDownListModule,
    DialogModule,
    ButtonsModule,
    UploadModule,
    ButtonGroupModule,
    SortableModule,
    GridModule,
    TabStripModule,
    PDFExportModule,
    ExcelModule,
    DateInputsModule,
    CgpBreadcrumbsModule,
    CgpSnackbarModule,
    CgpAppBarModule,
    CgpIdleModule,
    ExcelModule,
    MatTooltipModule,
    MatToolbarModule,
    MatSidenavModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    DataGridModule,
    FormDialogModule,
    CgpPanelModule,
    CgpUserProfileDialogModule,
    PipesModule,
    ExpandablePanelbarModule,

    CgpSidenavComponent,
    CgpFooterComponent,
    DataGridComponent,
    FormDialogComponent,
    NavToolbarModule,
    StepperComponent,
    ExpandablePanelbarComponent,
  ],

  providers: [
    AuthGuard,
    CgpAlertDialogModule,
    CgpConfirmationDialogModule,
    CgpBreadcrumbsModule,
    CgpSnackbarModule,
    CgpAppBarModule,
    CgpSidenavComponent,
    CgpFooterComponent,
    CgpApiService,
    CgpIdleService,
    CgpSidenavService,
    RouteValidationService,
  ],
})
export class SharedModule { }
